import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import config from "../config";
import methods from "../globals/global-methods"

//modules
import userModule from "./modules/UserModule";
import routeModule from "./modules/RouteModule";
import headingsModule from "./modules/HeadingsModule";
import languageModule from "./modules/LanguageModule";
import testModule from "./modules/TestModule";
import candidateModule from "./modules/CandidateModule";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
        ates: [],
        regions: [],
        progressbar: false,
        progressbarVisible: true,
        
    },
    getters: {
        getAtes: state => state.ates,
        getRegions: state => state.regions,
        isProgressbar: state => state.progressbar,
        isProgressbarVisible: state => state.progressbarVisible,
    },
    mutations: {
        SET_ATES: (state, ates) => {
            state.ates = ates;
        },
        SET_REGIONS: (state, regions) => {
            state.regions = regions;
        },
        SET_PROGRESSBAR: (state, status) => {
            state.progressbar = status;
        },
        SET_PROGRESSBAR_VISIBILITY: (state, status) => {
            state.progressbarVisible = status;
        },
        SET_TESTING: (state, test) => {
            state.testing = test;
        }
    },
    actions: {
        showProgressbar: ({commit}) => commit('SET_PROGRESSBAR', true),
        hideProgressbar: ({commit}) => commit('SET_PROGRESSBAR', false),
        setProgressbarVisible: ({commit}) => commit('SET_PROGRESSBAR_VISIBILITY', true),
        setProgressbarInvisible: ({commit}) => commit('SET_PROGRESSBAR_VISIBILITY', false),
        
        fetchAtes: async ({commit, state}) => {
            if (state.ates.length === 0) {
                try {
                    let response = await axios.get(config.urls.office.fetchAddressAtes.url);
                    return commit('SET_ATES', methods.objectToArray(response.data.data));
                } catch (error) {
                    console.log(error);
                }
            }
        },
        fetchRegions: async ({commit, state}) => {
            if (state.regions.length === 0) {
                try {
                    let response = await axios.post(config.urls.office.fetchAddressByLevel.url, {
                        level: 'region', id: 4948
                    });
                    return commit('SET_REGIONS', methods.objectToArray(response.data.data));
                } catch (error) {
                    console.log(error);
                }
            }
        }
    },
    modules: {
        user: userModule,
        route: routeModule,
        heading: headingsModule,
        language: languageModule,
        test: testModule,
        candidate: candidateModule,
    }
})
